// extracted by mini-css-extract-plugin
module.exports = {"UserImageInfo":"UserInfo_UserImageInfo__2vFsz","UserImage":"UserInfo_UserImage__1sR83","UserInfo":"UserInfo_UserInfo__22JBk","Link":"UserInfo_Link__rZDl2"};